import { useRef, useEffect } from 'react';

export function usePrevious<T>(value: T): T | undefined {
	const ref = useRef<T | undefined>(undefined);
	useEffect(() => {
		ref.current = value;
	});
	return ref.current;
}

// export function usePrevious<T>(value: T): T | undefined {
// 	const [current, setCurrent] = useState(value);
// 	const [previous, setPrevious] = useState<T | undefined>(undefined);

// 	if (!Object.is(value, current)) {
// 		setPrevious(current);
// 		setCurrent(value);
// 	}

// 	return previous;
// }
